import { render, staticRenderFns } from "./ChatChannel.vue?vue&type=template&id=61215091&scoped=true"
import script from "./ChatChannel.vue?vue&type=script&lang=js"
export * from "./ChatChannel.vue?vue&type=script&lang=js"
import style0 from "./ChatChannel.vue?vue&type=style&index=0&id=61215091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61215091",
  null
  
)

export default component.exports